import { useCustomers } from "./use-customers";

interface CustomerDisplayInfo {
  id: string;
  displayName: string;
  email: string;
}

export function useCustomerMapByIds(customerIds: string[]) {
  const customersQuery = useCustomers({
    pagination: {
      limit: 500,
    },
    orderBy: {
      field: "updatedAt",
      direction: "desc",
    },
  });

  const customers = customersQuery.data?.pages.flat() ?? [];
  const requestedIdSet = new Set(customerIds.filter((id) => id.length > 0));
  const customerMap = new Map<string, CustomerDisplayInfo>();

  for (const customer of customers) {
    if (!requestedIdSet.has(customer.id)) {
      continue;
    }

    const displayName = `${customer.firstName} ${customer.lastName}`.trim();
    customerMap.set(customer.id, {
      id: customer.id,
      displayName: displayName.length > 0 ? displayName : customer.email,
      email: customer.email,
    });
  }

  return {
    customerMap,
    customersQuery,
  };
}
